import { ContentPage } from '../page-factory/content-page';
import { maghuPurnimaPage } from '../pages/page-kumbh-2025.maghi-purnima';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(maghuPurnimaPage);

export default function MaghiPurnimaPage() {
  return <ContentPage {...maghuPurnimaPage} />;
}
